// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const PureRenderMixin = require('react-addons-pure-render-mixin');
const { connect } = require('react-redux');
// @ actions
const accountDebitsActions = require('actions/accountDebits');
const changeReceiptAccount = require('actions/contactCenter/changeReceiptAccount/changeReceiptAccount');
// @ components
const AccountDebitsChangeAccountView = require('components/contactCenter/accountDebitChange/accountDebitsChangeAccountView/accountDebitsChangeAccountView');

class AccountDebitChange extends React.Component {
    constructor(props) {
        super(props);
        this.reset = this.reset.bind(this);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    componentWillMount() {
        const {
            match: { params: { accountId, receiptNumber } },
            requestAccountDebits,
            immAccounts,
            setReceiptNumber,
            setCurrentAccountId
        } = this.props;

        const account = immAccounts.getIn(['byId', accountId]);
        requestAccountDebits(account);

        setReceiptNumber(receiptNumber);
        setCurrentAccountId(accountId);
    }

    reset() {
        this.props.reset();
    }

    render() {
        return (
            <AccountDebitsChangeAccountView
                {...this.props}
                reset={this.reset}
            />
        );
    }
}

AccountDebitChange.propTypes = {
    immAccountDebits: PropTypes.object,
    immAccounts: PropTypes.object,
    immProfile: PropTypes.object,
    requestAccountDebits: PropTypes.func,
    match: PropTypes.object,
    changeReceiptAccountConf: PropTypes.func.isRequired,
    reset: PropTypes.func,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    handleFinish: PropTypes.func.isRequired,
    setDestinationAccountId: PropTypes.func.isRequired,
    setCurrentAccountId: PropTypes.func.isRequired,
    setReceiptNumber: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    immChangeReceiptAccount: PropTypes.object,
};

module.exports.AccountDebitChange = connect(
    state => ({
        immProfile: state.profile,
        immAccountDebits: state.accountDebits,
        immAccounts: state.accounts,
        immChangeReceiptAccount: state.changeReceiptAccount,
    }), ({
        requestAccountDebits: accountDebitsActions.requestAccountDebits,
        changeReceiptAccountConf: changeReceiptAccount.changeReceiptAccountConf,
        validateStep: changeReceiptAccount.validateStep,
        reset: changeReceiptAccount.reset,
        setVisibleStep: changeReceiptAccount.setVisibleStep,
        setWillCancel: changeReceiptAccount.setWillCancel,
        handleFinish: changeReceiptAccount.finish,
        setCurrentAccountId: changeReceiptAccount.setCurrentAccountId,
        setDestinationAccountId: changeReceiptAccount.setDestinationAccountId,
        setReceiptNumber: changeReceiptAccount.setReceiptNumber,
    })
)(AccountDebitChange);
